export default __webpack_public_path__ + "static/media/MERCEDES-BENZ.64e211b8.png";